import round from 'lodash/round'

/** rounds a number to two or fewer decimals and returns a number */
export function roundPrice(n: number): number {
  const sanitized = n || 0
  return round(sanitized, 2)
}
